import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'form-title',
  templateUrl: './form-title.component.html',
  styleUrls: ['./form-title.component.less'],
})
export class FormTitleComponent implements OnInit {
  /**
   * title主标题
   */
  @Input() mainTitle: string = '';
  /**
   * title 副标题
   */
  @Input() secondaryTitle: string = '';
  /**
   * 右侧操作
   */
  @Input() operation: string = '';
  /**
   * 整体样式
   */
  @Input() style: object = {};

  constructor() {}

  ngOnInit(): void {}
}
